<template>
  <span>
    {{ typeDocument | typedocument
    }}<span v-if="dateDocument"
      >, {{ typeDocument | libelledatedocument }} : {{ dateDocument | date
      }} <span v-if="dateEffet">,
            {{ typeDocument | libelledateeffet }} :
           {{ dateEffet | date }}
          </span><template v-if="sousType"
        >, Sous-type : {{ sousType | soustypedocument }}</template
      >
      <template v-if="journal"
        >, Journal d'annonces légales : {{ journal }}</template
      >
    </span>
    <template v-if="nomDocument">
      - <em>{{ nomDocument }}</em>
    </template>
    <template v-if="telechargeable"
      >- {{ typeFichier }} - {{ tailleDocument | bytes }}</template
    >
  </span>
</template>

<script>
import makeDocumentComponent from "@/mixins/document/makeDocumentComponent";
export default {
  mixins: [makeDocumentComponent()],
};
</script>

